<another-instance-modal modalClass="public-application-modal">
</another-instance-modal>